import styled from '@emotion/styled';
import { colors, spacing, typography, overlayColor, breakpoint } from 'component-library';
import { maxmq } from '../../assets/styles/breakpoints';

export const MobileMenuWrapper = styled.div`
  display: none;
  margin-right: ${spacing.xxsmall};
  ${maxmq[2]} {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 24px;
  }
`;

export const MenuButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MenuButton = styled.button`
  border: 0;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  margin: 0;
  outline: none;
`;

export const MobileMenuFoldout = styled.div<{ hasNavWatermark: boolean }>`
  position: fixed;
  z-index: 100;
  top: ${({ hasNavWatermark }) => (!hasNavWatermark ? spacing.xxlarge : '96px')};
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${overlayColor};
`;

export const MobileMenuFoldoutList = styled.ul<{ hasNavWatermark: boolean }>`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: ${colors.base.white};
  max-height: calc(100% - ${({ hasNavWatermark }) => (hasNavWatermark ? '96px' : '72px')});
  overflow-y: auto;
`;

export const MobileMenuFoldoutListItem = styled.li`
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  border-bottom: 1px solid ${colors.monochrome.grey20};
  display: flex;
  align-items: center;
`;

export const MobileMenuLink = styled.a<{ isActive: boolean }>`
  padding: ${spacing.xsmall} ${spacing.mediumHigh};
  width: 100%;
  ${typography.other.burgerMenuLabel};
  color: ${({ isActive }) => (isActive ? colors.primary.blue : colors.base.black)};
  text-decoration: none;

  @media (max-width: ${breakpoint.small}px) {
    padding-left: ${spacing.small};
    padding-right: ${spacing.small};
  }
`;
